module.exports = __webpack_public_path__ + "img/720.89b3f8f8.jpg";